import { Menu, Transition } from '@headlessui/react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon } from '@heroicons/react/solid'

export default function Dropdown() {
    const navigate = useNavigate();

    const goInvestDef = () => {
        navigate("/InvestDef");
    };

    const goInvestRisk = () => {
        navigate("/InvestRisk");
    };

    const goInvestFactors = () => {
        navigate("/InvestFactors");
    };

    const goInvestPortfolio = () => {
        navigate("/InvestPortfolio");
    };

    const goStockDef = () => {
        navigate("/StockDef");
    };

    const goBuyAndSellStock = () => {
        navigate("/BuyAndSellStock");
    };

    const goStockFactors = () => {
        navigate("/StockFactors");
    };

    const goBondsDef = () => {
        navigate("/BondsDef");
    };

    const goBuyAndSellBonds = () => {
        navigate("/BuyAndSellBonds");
    };

    const goMutualFunds = () => {
        navigate("/MutualFunds");
    };

    const goStockFunds = () => {
        navigate("/StockFunds");
    };

    const goBondFunds = () => {
        navigate("/BondFunds");
    };

    const goMarketAndTargetFunds = () => {
        navigate("/MarketAndTargetFunds");
    };

    const goHedgeFunds = () => {
        navigate("/HedgeFunds");
    };

    const goSavingsDef = () => {
        navigate("/SavingsDef");
    };

    const goInterestDef = () => {
        navigate("/InterestDef");
    };

    const goInterestFactors = () => {
        navigate("/InterestFactors");
    };

    return (
    <div className="w-56 text-left absolute top-[15%] left-[8.5%]">
    <Menu as="div" className="relative inline-block text-center">
        <div>
        <Menu.Button className="inline-flex justify-center w-full px-2 py-2 text-sm font-medium text-white bg-blueInFigma rounded-md hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <ChevronDownIcon
            className="w-5 h-5 ml-0 -mr-0 text-white hover:text-gray-100"
            aria-hidden="true"
            />
        </Menu.Button>
        </div>
        <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
        >
        <Menu.Items className="fixed left-10 w-56 mt-2 bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md jusitfy-items-start w-full px-1 py-1 text-sm`}
                    onClick={goInvestDef}
                >
                    What is Investing?
                </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md justify-items-start w-full px-1 py-1 text-sm`}
                    onClick={goInvestRisk}
                >
                    Risk
                </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md items-start justify-self-start px-1 py-1 text-sm`}
                    onClick={goInvestFactors}
                >
                    Factors to Consider When Investing
                </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md justify-items-start w-full px-1 py-1 text-sm`}
                    onClick={goInvestPortfolio}
                >
                    Investment Portfolio
                </button>            
                )}
            </Menu.Item>
            </div>
            <div className="px-1 py-1">
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md items-center w-full px-1 py-1 text-sm`}
                    onClick={goStockDef}
                >
                    What is Stock?
                </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                <button
                    className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                    } group rounded-md items-center w-full px-1 py-1 text-sm`}
                    onClick={goBuyAndSellStock}
                >
                    Buying And Selling Stock
                </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                    onClick={goStockFactors}
                    >
                        Factors that Affect Stock
                    </button>
                )}
            </Menu.Item>
            </div>
            <div className="px-1 py-1">
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                    onClick={goBondsDef}
                    >
                        What are Bonds?
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                        onClick={goBuyAndSellBonds}
                    >
                        Buying and Selling Bonds
                    </button>
                )}
            </Menu.Item>
            </div>
            <div className="px-1 py-1">
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goMutualFunds}
                    >
                        Mutual Funds
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goStockFunds}
                    >
                        Stock Funds
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goBondFunds}
                    >
                        Bond Funds
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goMarketAndTargetFunds}
                    >
                        Money Market and Target-Date Funds
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                        onClick={goHedgeFunds}
                    >
                        Hedge Funds
                    </button>
                )}
            </Menu.Item>
            </div>
            <div className="px-1 py-1">
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goSavingsDef}
                    >
                        What are Savings?
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goInterestDef}
                    >
                        Interest
                    </button>
                )}
            </Menu.Item>
            <Menu.Item>
                {({ active }) => (
                    <button
                        className={`${active ? 'bg-gray-500 text-white' : 'text-gray-900'
                            } group rounded-md items-center w-full px-1 py-1 text-sm`}
                                        onClick={goInterestFactors}
                    >
                        Factors that Affect Interest
                    </button>
                )}
            </Menu.Item>
            </div>
        </Menu.Items>
        </Transition>
    </Menu>
    </div>
    )
}